import React, { Fragment } from 'react';
import { States } from '@/helpers/common/states';
import { ProducerProductLink } from '@/model/ProducerProductLinkDTO';
import { Button, InputText, Loading } from '@/components';
import { Col, Container, Row } from 'reactstrap';
import { ChangeType } from '@/features/producerProduct/types';

interface StateProps {
  state: States;
  producerProductLink?: ProducerProductLink;
}

interface DispatchProps {
  onChange: (changeType: ChangeType, groupIx: number, productIx: number, value: string) => void;
  onRefused: () => void;
  onValidate: () => void;
}

type Props = StateProps & DispatchProps;

export const ProducerProductDetailContainer: React.FC<Props> = ({
  state,
  producerProductLink,
  onChange,
  onRefused,
  onValidate,
}): JSX.Element => (
  <Fragment>
    <Loading isVisible={state === States.loading} />
    <Container className="mainContainer" fluid={true}>
      <div className="container-event">
        <h5 className="mb-2 border-bottom-title mb-5">Confirmação de dados</h5>
      </div>
      {producerProductLink && (
        <div style={{ overflow: 'auto' }}>
          <div className="mb-2">
            <h6 className="mb-0">Evento</h6>
            {producerProductLink.event.name}
          </div>
          <div className="mb-2">
            <h6 className="mb-0">Setor</h6>
            {producerProductLink.section.name}
          </div>

          <h6 className="mb-2">Grupos</h6>
          <hr />
          {producerProductLink.groups &&
            producerProductLink.groups.length > 0 &&
            producerProductLink.groups.map((group, index) => (
              <Fragment key={`group-${group.name}`}>
                <h6 className="mb-4">{group.name}</h6>

                <Row>
                  <Col md={6}>
                    <table width={'100%'}>
                      <thead>
                        <tr>
                          <td width={'70%'}>
                            <label className={'input-label m-0'}>Produto</label>
                          </td>
                          <td>
                            <label className={'input-label m-0'}>Valor</label>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        {group.products.map((product, ix) => (
                          <tr key={`product-${product.name}`}>
                            <td>
                              <InputText
                                name={`product-name-${ix}`}
                                value={product.name}
                                onChange={e =>
                                  onChange(ChangeType.PRODUCT_NAME, index, ix, e.target.value)
                                }
                              />
                            </td>
                            <td>
                              <InputText
                                name={`product-price-${ix}`}
                                value={`${product.price}`}
                                onChange={e =>
                                  onChange(ChangeType.PRODUCT_PRICE, index, ix, e.target.value)
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Col>
                </Row>
              </Fragment>
            ))}
        </div>
      )}
      <hr />
      <div className="footer-register-event">
        <Button title="Recusar" theme="noneBorder" onClick={() => onRefused()} />
        <Button type="button" title="Acatar" onClick={() => onValidate()} />
      </div>
    </Container>
  </Fragment>
);
